import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import { Radio } from '@delmonicos/shared-design-system-react/src/components/radio/radio';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { OcppMessageType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/get-charge-point-ocpp-logs.model';
import { useTranslation } from 'react-i18next';

interface ByTypeFilterComponentProps {
  selectedOcppMessageType: OcppMessageType[];
  handleSelectedOcppMessageType: (messageTypes: OcppMessageType[]) => void;
}

export const ByTypeFilterComponent = ({
  selectedOcppMessageType,
  handleSelectedOcppMessageType,
}: ByTypeFilterComponentProps): React.JSX.Element => {
  const { t } = useTranslation();

  const handleSelectAll = () => {
    handleSelectedOcppMessageType([
      OcppMessageType.callError,
      OcppMessageType.callResult,
    ]);
  };

  const handleSelectResult = () => {
    handleSelectedOcppMessageType([OcppMessageType.callResult]);
  };

  const handleSelectError = () => {
    handleSelectedOcppMessageType([OcppMessageType.callError]);
  };

  return (
    <Stack gap={GapEnum.M} direction="column">
      <IconText
        iconName="marker-pin-01"
        text={t('$.charge-point-details.maintenance.filter.type.title')}
      />

      <Radio
        label={t('$.charge-point-details.maintenance.filter.type.all')}
        checked={selectedOcppMessageType.length === 2}
        onChange={handleSelectAll}
      />

      <Radio
        label={t('$.charge-point-details.maintenance.filter.type.result')}
        checked={
          selectedOcppMessageType.length === 1 &&
          selectedOcppMessageType.includes(OcppMessageType.callResult)
        }
        onChange={handleSelectResult}
      />

      <Radio
        label={t('$.charge-point-details.maintenance.filter.type.error')}
        checked={
          selectedOcppMessageType.length === 1 &&
          selectedOcppMessageType.includes(OcppMessageType.callError)
        }
        onChange={handleSelectError}
      />
    </Stack>
  );
};
